// assets/staffelpreise.js
document.addEventListener("DOMContentLoaded", function () {
  // ----- Ersparnis-Styles -----
  if (!document.getElementById("sp-save-top-styles")) {
    const css = `
  .sp-save-top{
    width:100%;
    margin-top:2px 0 -8px 0;     /* FAST KEIN ABSTAND OBEN */
    padding:12px 16px;
    background:#f6fef9;
    border:1px solid #d1fadf;
    border-radius:12px;
    
    font-size:.9rem;
    line-height:1.45;
    display:flex;
    flex-direction:column;
    gap:6px;
  }

  .sp-save-top__title{
    font-weight:700;
    font-size:.9rem;
    color:#166534;
    text-transform:none;
    letter-spacing:0;
    margin-bottom:2px;
  }

  .sp-save-top__line{
    display:flex;
    flex-wrap:wrap;
    gap:6px;
  }

  .sp-save-top__label{
    opacity:.7;
  }

  .sp-save-top__value{
    font-weight:700;
    color:#065f46;
  }

  .sp-save-top__pill{
    padding:2px 8px;
    border-radius:999px;
    font-size:.75rem;
    background:#dcfce7;
    color:#166534;
  }

  .sp-save-top__pill--worse{
    background:#fee2e2;
    color:#b91c1c;
  }
`;
    const s = document.createElement("style");
    s.id = "sp-save-top-styles";
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  }

  // ----- Tabellen-Styles (mit "nur Nachbarn" + Toggle) -----
  if (!document.getElementById("sp-table-styles")) {
    const css = `
      .sp-table-wrap{
        padding:6px 0;
        line-height:1.3;
        overflow-x:auto;
      }
      .sp-table{
        width:100%;
        border-collapse:collapse;
      }
      .sp-table th,
      .sp-table td{
        padding:8px 10px;
        border-bottom:1px solid rgba(0,0,0,.08);
        text-align:center;
        font-size:.95rem;
        white-space:nowrap;
      }
      .sp-table thead th{
        font-weight:600;
      }

      /* Basis immer normal – Theme-Styles überschreiben */
      .sp-table tbody tr td{
        font-weight:400 !important;
      }

      /* Nur die aktive Zeile fett */
      .sp-table tbody tr.sp-row--active td{
        font-weight:700 !important;
      }

      .sp-table-wrap--collapsed .sp-row--extra{display:none;}
      .sp-toggle-all{
        margin-top:8px;
        font-size:.9rem;
        text-decoration:underline;
        background:none;
        border:0;
        padding:0;
        cursor:pointer;
      }
      .sp-toggle-all:focus{
        outline:2px solid #000;
        outline-offset:2px;
      }
    `;
    const s = document.createElement("style");
    s.id = "sp-table-styles";
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  }

  // ----- Bootstrap aus Liquid -----
  const container = document.getElementById("staffelpreise-container");
  if (!container) return;

  const variantData  = Array.isArray(window.__SP_VARIANTS__) ? window.__SP_VARIANTS__ : [];
  const staffelInfo  = (typeof window.__SP_META__ === "object" && window.__SP_META__) ? window.__SP_META__ : {};
  const selectedDefault = window.__SP_SELECTED__ || null;

  // ===== Helpers =====
  function formatPrice(n){
    const num = Number(n);
    if (Number.isNaN(num)) return String(n);
    return num.toFixed(2).replace('.', ',');
  }

  function getVariantIdFromUrl() {
    try {
      const p = new URLSearchParams(window.location.search);
      if (p.has("variant")) {
        const v = p.get("variant");
        return v === "" ? null : v;
      }
    } catch(e){}
    return selectedDefault;
  }

  // Zahl + Einheit aus Text ziehen. Liefert {qty:Number, unit:"m"|"pcs"|null}
  const UNIT_ALIASES = {
    m:   ["m","meter"],
    pcs: ["stück","stueck","stk","pcs","piece","pieces"]
  };
  function normalizeUnit(u){
    const s = (u||"").toLowerCase();
    if (UNIT_ALIASES.m.includes(s))   return "m";
    if (UNIT_ALIASES.pcs.includes(s)) return "pcs";
    return null;
  }
  function parseQtyUnit(str){
    if (!str) return { qty:null, unit:null };
    const s = String(str).toLowerCase().trim();
    // z.B. "12,5 m" | "20 stück" | "8 pcs" | "32 stk"
    const m = s.match(/(\d+(?:[.,]\d+)?)\s*(m|meter|stück|stueck|stk|pcs|piece|pieces)\b/);
    if (!m) return { qty:null, unit:null };
    return { qty: parseFloat(m[1].replace(',','.')), unit: normalizeUnit(m[2]) };
  }

  function getOptionsArray(v){ return [v.option1, v.option2, v.option3].filter(Boolean); }
  function extractQtyFromVariant(v){
    const c1 = parseQtyUnit(v.option1);
    const c2 = parseQtyUnit(v.option2);
    const c3 = parseQtyUnit(v.option3);
    const ct = parseQtyUnit(v.title);
    return c1.qty!=null?c1:(c2.qty!=null?c2:(c3.qty!=null?c3:ct));
  }
  function getNonQtyOptions(v){
    return getOptionsArray(v).filter(val => parseQtyUnit(val).qty == null);
  }

  // Liest eine Tier-Zeile und bringt sie auf {qty, unit, price}
  function normalizeTier(t){
    // akzeptiere length_m, qty, pieces
    let qty = null;
    let unit = null;
    if (t.length_m != null){ qty = Number(t.length_m); unit = "m"; }
    if (t.qty != null){      qty = Number(t.qty);      if (!unit) unit = null; }
    if (t.pieces != null){   qty = Number(t.pieces);   unit = "pcs"; }
    // falls Metafeld zusätzlich "unit" hat
    if (!unit && typeof t.unit === "string") unit = normalizeUnit(t.unit);
    return { qty: qty, unit: unit, price: Number(t.price) };
  }

  // ===== Render =====
  function render(variantId) {
    container.innerHTML = "";
    if (!variantId) return;

    const selectedVariant = variantData.find(v => String(v.id) === String(variantId));
    if (!selectedVariant) return;

    const meta = staffelInfo[variantId];
    if (!meta || !Array.isArray(meta.tiers) || !meta.tiers.length) return;

    const currency = meta.currency || 'EUR';

    // Welche Einheit hat die Variante? (m oder pcs)
    const sel = extractQtyFromVariant(selectedVariant); // {qty, unit}
    const selectedQty = sel.qty;
    const unit = sel.unit || (typeof meta.unit === "string" ? normalizeUnit(meta.unit) : null);

    // Fallback: wenn keine Einheit erkannt, nehmen wir "pcs"
    const finalUnit = unit || "pcs";
    const labelQty   = finalUnit === "m"   ? "Länge (m)"  : "Stück";
    const labelPpu   = finalUnit === "m"   ? "Preis / m"  : "Preis / Stk";

    const baseNonQtyOptions = getNonQtyOptions(selectedVariant);

    // Live-Preise ermitteln (Variante mit gleicher qty + gleichen Nicht-Mengen-Optionen)
    const normalizedTiers = meta.tiers.map(normalizeTier).filter(t => t.qty != null);
    const liveTiers = normalizedTiers.map(function(tier){
      const targetQty = Number(tier.qty);

      const matchVar = variantData.find(function(v){
        const info = extractQtyFromVariant(v);
        if (info.qty !== targetQty) return false;
        // gleiche nicht-mengen Optionen (Farbe etc.)
        const candOpts = getNonQtyOptions(v);
        return baseNonQtyOptions.every(val => candOpts.includes(val));
      });

      const livePrice = matchVar ? (matchVar.price / 100) : Number(tier.price);
      return { qty: targetQty, price: livePrice };
    });

    if (!liveTiers.length) return;

    // Sortiert
    const sorted = liveTiers.slice().sort((a,b) => a.qty - b.qty);
    const minTier = sorted[0] || null;

    // Index & Tier der aktuell gewählten Menge finden
    let selectedIndex = -1;
    let currentTier = null;
    if (selectedQty != null) {
      for (let i = 0; i < sorted.length; i++) {
        if (sorted[i].qty === selectedQty) {
          selectedIndex = i;
          currentTier = sorted[i];
          break;
        }
      }
    }
    if (selectedIndex === -1) {
      selectedIndex = 0;
      currentTier = sorted[0];
    }

    // ---- HTML
    let html = '<div class="sp-table-wrap sp-table-wrap--collapsed">';

    // Ersparnis-Box (pro Einheit + gesamt) – immer vs. günstigster Stufe
    if (currentTier && minTier && selectedQty && selectedQty !== minTier.qty) {
      const minPPU    = minTier.price / minTier.qty;
      const curPPU    = currentTier.price / currentTier.qty;
      const diffPer   = curPPU - minPPU;              // €/Einheit
      const diffTotal = currentTier.price - minTier.price; // €/Gesamt

      if (Math.abs(diffPer) > 1e-6 || Math.abs(diffTotal) > 1e-6) {
        const unitLabel = finalUnit === "m" ? "Meter" : "Stück";
        const selLabel  = finalUnit === "m" ? " m" : " Stk";

        html += '<div class="sp-save-top">';
        html +=   '<div class="sp-save-top__title">Ersparnis</div>';

        // Zeile: pro Einheit
        html +=   '<div class="sp-save-top__line">';
        html +=     '<span class="sp-save-top__label">pro ' + unitLabel + ':</span>';
        html +=     '<span class="sp-save-top__value">' +
                      formatPrice(Math.abs(diffPer)) + ' ' + currency +
                    '</span>';
        html +=     '<span class="sp-save-top__pill ' +
                      (diffPer > 0 ? 'sp-save-top__pill--worse' : '') +
                    '">';
        html +=       (diffPer < 0 ? 'günstiger' : (diffPer > 0 ? 'teurer' : 'gleich'));
        html +=     '</span>';
        html +=   '</div>';

        // Zeile: insgesamt
        html +=   '<div class="sp-save-top__line">';
        html +=     '<span class="sp-save-top__label">insgesamt (' +
                      String(selectedQty).replace('.', ',') + selLabel +
                    '):</span>';
        html +=     '<span class="sp-save-top__value">' +
                      formatPrice(Math.abs(diffTotal)) + ' ' + currency +
                    '</span>';
        html +=     '<span class="sp-save-top__pill ' +
                      (diffTotal > 0 ? 'sp-save-top__pill--worse' : '') +
                    '">';
        html +=       (diffTotal < 0 ? 'günstiger' : (diffTotal > 0 ? 'teurer' : 'gleich'));
        html +=     '</span>';
        html +=   '</div>';

        html += '</div>';
      }
    }

    // Tabelle: erst nur aktuelle + Nachbarn
    html += '<table class="sp-table"><thead><tr>' +
              '<th>'+labelQty+'</th>' +
              '<th>Preis ('+currency+')</th>' +
              '<th>'+labelPpu+'</th>' +
            '</tr></thead><tbody>';

    for (let i = 0; i < sorted.length; i++) {
      const t = sorted[i];
      const ppu = t.price / t.qty;

      const isActive = (t.qty === selectedQty);
      const isVisibleNeighbor =
        i >= Math.max(0, selectedIndex - 1) &&
        i <= Math.min(sorted.length - 1, selectedIndex + 1);

      let rowClass = "";
      if (isActive) rowClass += " sp-row--active";
      if (!isVisibleNeighbor) rowClass += " sp-row--extra";

      html += '<tr class="' + rowClass.trim() + '">';
      html +=   '<td>'+ String(t.qty).replace('.', ',') +'</td>';
      html +=   '<td>'+ formatPrice(t.price) +' '+currency+'</td>';
      html +=   '<td>'+ formatPrice(ppu) +' '+currency+'</td>';
      html += '</tr>';
    }

    html += '</tbody></table>';

    // Toggle-Button
    if (sorted.length > 3) {
      html += '<button type="button" class="sp-toggle-all" data-sp-toggle>' +
                'Alle Staffelpreise anzeigen' +
              '</button>';
    }

    html += '</div>'; // .sp-table-wrap

    container.innerHTML = html;

    // Toggle-Logik nach dem Rendern
    const wrap = container.querySelector(".sp-table-wrap");
    const toggleBtn = container.querySelector("[data-sp-toggle]");
    if (wrap && toggleBtn) {
      toggleBtn.addEventListener("click", function(){
        const collapsed = wrap.classList.toggle("sp-table-wrap--collapsed");
        toggleBtn.textContent = collapsed
          ? "Alle Staffelpreise anzeigen"
          : "Weniger Staffelpreise anzeigen";
      });
    }
  }

  // ===== Trigger =====
  const updateFromUrl = () => render(getVariantIdFromUrl());

  updateFromUrl();
  window.addEventListener("popstate", updateFromUrl);

  let last = location.href;
  setInterval(function(){
    if (location.href !== last) { last = location.href; updateFromUrl(); }
  }, 300);

  document.addEventListener('variant:change', updateFromUrl);

  const idInput = document.querySelector('form[action^="/cart/add"] input[name="id"]');
  if (idInput && 'MutationObserver' in window){
    new MutationObserver(updateFromUrl).observe(idInput,{attributes:true,attributeFilter:['value']});
  }
  document.addEventListener('change', function(e){
    if (e.target && e.target.closest('form[action^="/cart/add"]')) updateFromUrl();
  });
});